import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import {
  removeSaveProgress,
  setSaveProgress,
} from "Actions/SaveProgressAction";
import classnames from "classnames";
import CallOutNew from "Component/Headers/callOutNew";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import Dropzone from "react-dropzone";
import { Helmet } from "react-helmet";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";
import * as _ from "underscore";
import loader from "Assets/Gif/loader.gif";
import {
  instance,
  instanceMultipart,
} from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonReducerAction,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import Clock from "../../../../../Assets/Icons/Clock-time/clock-time-16px.svg";
import EmpProfile from "../../../../../Assets/Icons/profile.png";
import defaultEmp from "../../../../../Assets/Images/defaultEmp.svg";
import Sun from "../../../../../Assets/Images/sunny.png";
import curvedArrow from "../../../../../Assets/Svg/curved-arrow.svg";
import defaultstateimg from "../../../../../Assets/Svg/group-3.svg";
import TabContainer from "../../../../../Component/Common/TabContainer";
import { DatePickerComponent } from "../../../../../Component/Custom";
import DefaultComp from "../../../../../Component/DefaultComp/Defaultstatecomp";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import InputValues from "../../../../../Component/InputValues";
// import TextArea from "../../Component/Material-ui/TextArea";
import TextArea from "../../../../../Component/Material-ui/TextArea";
import { ReducersTypes } from "../../../../../Constants";
import { FEATUREKEYS } from "../../../../../Constants/Featurekeys";
import headersList from "../../../../../Constants/headersList";
import createstore from "../../../../../store";
import {
  convertDateForBackend,
  getEJ2CalenderDateFormat,
  getEJ2CalenderMonthFormat,
  getFormattedDate,
  getFormattedImageLink,
} from "../../../../../Utils";
import "./index.css";
import LeaveTypeWidget from "./LeaveTypeWidget";
import Ledger from "./Ledger";

const styles = (theme) => ({
  drawerPaper: {
    width: "30%",
  },
});

function LabelValue({ label, value }) {
  return (
    <div className="margin-bottom-16">
      <p className="t-14 normal-dark-secondary floatleft">{label}</p>
      <p className="t-14 normal-dark-secondary floatright t-bold margin-right-4">
        {value}
      </p>
      <div className="clear-float"></div>
    </div>
  );
}

class LeaveBalance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      monthList: [],
      onetime: true,
      right: false,
      value: 0,
      defaultstate: false,
      empList: [],
      AllSubEmployee: [],
      SelectedEmpData: null,
      isFromModule: false,
      leaveAction: [
        // { displayvalue: 1, displayname: "View Policy" },
        { displayvalue: 1, displayname: "View Logs" },
        { displayvalue: 2, displayname: "Ledger" },
      ],
      Leaveactiontype: [
        { value: 1, label: "Full day" },
        { value: 2, label: "First half" },
        { value: 3, label: "Second half" },
      ],

      todayLeaveDate: new Date(),
      leaveRequest: [],
      leaveHistory: [],
      Leavetypeslist: [],
      Leavetypeslist1: [],
      filterLeaveTypes: [],
      SelectedMonth: new Date(),
      leaveCycleList: [],
      leavecycleduration: { displayname: null, displayvalue: null },
      leaveList: [],

      leaveLogs: [],
      designationList: [],
      expanded: false,
      expandDebit: false,
      accountid: null,
      subscriptionid: null,
      SelectedTagIds: null,
      empTaglist: null,
      SelectedEmpId: null,
      SelectedEmp: {},
      leaveid: 0,
      backupleave: {},
      selectedLeave: {},
      selectedLeave1: { leavetypeid: 0 },
      recipient: null,
      senderid: null,
      leavepolicyid: null,
      leavetypeid: null,
      leavecategoryid: null,
      fromdatetime: null,
      todatetime: null,
      leavestarttypeid: 1,
      leaveendtypeid: 1,
      comment: null,
      file: null,
      imgname: null,
      totime: null,
      fromtime: null,
      isvisible: false,
      isleavepolicyassigned: null,
      creditLeavesCount: 0,
      debitLeavesCount: 0,
      creditComment: null,
      debitComment: null,
      displaymonthvaluedata: null,
      giftpolicyDetail: {},
      leavecount: 0,
      minApplyDate: new Date(),
      empdoj: "",
      selecteddaytype: 1,
      // weekoffleaves: [{ crediteddata: 0, crediteddate: "2019-03-02" }],
    };

    this.changeleavetype = this.changeleavetype.bind(this);
    this.onChangeDayType = this.onChangeDayType.bind(this);
    this.changestartleavetype = this.changestartleavetype.bind(this);
    this.changeendleavetype = this.changeendleavetype.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.showLeavePolicy = this.showLeavePolicy.bind(this);
    this.GetEmpDoj = this.GetEmpDoj.bind(this);
    this.selectDate = this.selectDate.bind(this);
    this.cleardrawerData = this.cleardrawerData.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission(
      "leaveBalanceAndHistory",
    );
    if (isTrue) {
      this.setState({ permissions }, () => {
        const isFromModule = this.props.match.path == "/app/track/leave";
        if (isFromModule) {
          const masterprofileid = get(
            this.props,
            "AuthenticationAction.login.masterprofileid",
            "",
          );
          if (masterprofileid != 9) {
            this.GetEmployeeDetails();
          }
        } else {
          this.Getleavetypes();
          this.GetEmpDoj();
        }

        const { SubscriptionInfo } = this.props;
        const accountid = get(
          SubscriptionInfo,
          "SubscriptionData.accountid",
          "",
        );
        const subscriptionid = get(
          SubscriptionInfo,
          "SubscriptionData.subscriptionid",
          "",
        );
        const masterprofileid = get(
          this.props,
          "AuthenticationAction.login.masterprofileid",
          "",
        );
        const employeeid = get(
          this.props,
          "AuthenticationAction.login.employeeid",
          "",
        );
        this.setState({
          subscriptionid,
          accountid,
          masterprofileid,
          isFromModule,
          employeeid,
          // SelectedEmp: this.state.empList.filter((item) => item.displayvalue == this.state.empList),
        });
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillMount() {
    this.props.ChangeLanguage("leavebalance");
  }

  toggleDrawer = (side, open, flag, leaveoption) => {
    console.log("leaveoption: ", leaveoption);
    if (leaveoption) {
      const { AuthenticationAction } = createstore.getState();
      // let SelectedEmpId = AuthenticationAction.login.employeeid;
      const senderid = AuthenticationAction.login.employeeid;
      const selectedLeave = this.state.Leavetypeslist.find(
        (x) => x.leaveid == leaveoption.leaveid,
      );
      this.setState({
        selectedLeave,
        // SelectedEmpId,
        selectedLeave1: selectedLeave,
        backupleave: selectedLeave,
        senderid,
      });
    }
    switch (flag) {
      case "GiftTypeLeave":
        {
          if (!leaveoption.isgiftallowed) {
            this.props.enqueueSnackbar(
              "error.response ? error.response.data.error.message : error.message",
              { variant: "error" },
            );
            return false;
          }
          const giftpolicyDetail = {
            giftedbyleavepolicyid: leaveoption.leavepolicyid,
            giftedbyleaveid: leaveoption.leaveid,
            giftedbyleavetypeid: leaveoption.leavetypeid,
            giftedbyleavecategoryid: leaveoption.leavecategoryid,
          };
          this.setState(
            {
              SelectedEmp: null,
              giftpolicyDetail,
              giftLeave: true,
              applyLeave: false,
              viewLogs: false,
              ledger: false,
              leavecount: 0,
              emplist: [],
            },
            () => {
              this.AllSubEmployee();
              this.GetApproverList();
            },
          );
        }
        break;
      case "ApplyLeave":
        {
          const url = `leaves/initleaveapply/${
            this.state.SelectedEmpId ? this.state.SelectedEmpId : ""
          }`;

          // console.log("case");
          instance
            .get(url)
            .then((result) => {
              let date = null;
              let minApplyDate = null;
              if (result.data.result[0]) date = result.data.result[0].doj;

              if (date) minApplyDate = moment(date).format();
              this.setState(
                {
                  giftLeave: false,
                  applyLeave: true,
                  viewLogs: false,
                  ledger: false,
                  minApplyDate,
                  SelectedEmpData: this.state.SelectedEmpData1,
                  SelectedEmp: this.state.SelectedEmpData1,
                  selectedLeave: this.state.backupleave,
                  selectedLeave1: this.state.backupleave,
                  // SelectedEmpId: this.state.SelectedEmpData1.displayvalue,
                  value: this.props.match.path == "/app/track/leave" ? 1 : 0,
                },
                () => {
                  this.GetEmployeeDetails();
                  this.GetApproverList();
                },
              );
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        }
        break;
      case "Ledger":
        // this.LoadLedger(leaveoption);
        this.setState({
          giftLeave: false,
          applyLeave: false,
          viewLogs: false,
          ledger: true,
          expanded: false,
          creditLeavesCount: 0,
          debitLeavesCount: 0,
          creditComment: null,
          debitComment: null,
          expandDebit: false,
          leaveoption,
        });
        break;
      case "ViewLogs":
        this.setState(
          {
            giftLeave: false,
            applyLeave: false,
            viewLogs: true,
            ledger: false,
          },
          () => {
            this.Getleavelogs();
          },
        );
        break;
      default:
        this.ClearState();
        break;
    }
    this.setState({
      [side]: open,
    });
  };

  GetEmpDoj() {
    const url = "leaves/initleaveapply";
    instance
      .get(url)
      .then((result) => {
        let date = null;
        let minApplyDate = null;
        if (result.data.result[0]) date = result.data.result[0].doj;
        if (date) minApplyDate = moment(date, "YYYY-MM-DD").format();
        this.setState({
          minApplyDate,
          isleavepolicyassigned:
            result.data.result[0] &&
            result.data.result[0].isleavepolicyassigned,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  ClearState() {
    this.setState({
      SelectedEmpId: null,
      senderid: null,
      recipient: null,
      selectedLeave1: { leavetypeid: 0 },
      selectedLeave: { leavetypeid: 0 },
      fromdatetime: null,
      todatetime: null,
      // leavestarttypeid: { value: 1, label: "Full day" },
      leavestarttypeid: 1,
      leaveendtypeid: 1,
      comment: null,
      file: null,
      imgname: null,
      empTaglist: null,
      emplist: [],
      SelectedTagIds: null,
      value: 0,
      selecteddaytype: 1,
    });
  }

  handleChange = (event, value) => {
    this.setState(
      {
        value,
        recipient: null,
        fromdatetime: null,
        todatetime: null,
        // leavestarttypeid: { value: 1, label: "Full day" },
        leavestarttypeid: 1,
        leaveendtypeid: 1,
        comment: null,
        file: null,
        imgname: null,
        empTaglist: null,
        SelectedTagIds: null,
        SelectedEmp: this.state.SelectedEmpData1,
        SelectedEmpData: this.state.SelectedEmpData1,
        // selectedLeave: this.state.backupleave,
        // selectedLeave1: this.state.backupleave,
        selectedLeave:
          this.props.match.path != "/app/track/leave" && value == 1
            ? {}
            : this.state.backupleave,
        selectedLeave1:
          this.props.match.path != "/app/track/leave" && value == 1
            ? { leavetypeid: 0 }
            : this.state.backupleave,
        selecteddaytype: 1,
      },
      () => {
        let SelectedEmpId = null;
        if (this.state.value == 0) {
          SelectedEmpId =
            createstore.getState().AuthenticationAction.login.employeeid;
        }
        this.setState({ SelectedEmpId });
      },
    );
  };

  UpdateSelectedTagIds(selectedItems) {
    let empTaglist = [];
    for (const item of selectedItems) {
      empTaglist.push(item.displayvalue);
    }
    if (empTaglist.length < 0) empTaglist = null;
    this.setState({ SelectedTagIds: selectedItems, empTaglist });
  }

  UpdateSelectedEmpId(selectedItem) {
    console.log("selectedItem: ", selectedItem);
    const { Leavetypeslist1 } = this.state;
    console.log("Leavetypeslist1: ", Leavetypeslist1);
    this.setState(
      {
        SelectedEmpId: selectedItem.displayvalue,
        SelectedEmpId1: selectedItem.displayvalue,
        SelectedEmp: selectedItem,
        selectedLeave: {},
        selectedLeave1: { leavetypeid: 0 },
        onetime: false,
      },
      () => {
        if (!this.state.giftLeave) {
          this.Getleavetypesforsomeonelse();
          this.GetApproverList();
          const url = `leaves/initleaveapply/${this.state.SelectedEmpId}`;
          instance
            .get(url)
            .then((result) => {
              let date = null;
              let minApplyDate = null;
              if (result.data.result[0]) date = result.data.result[0].doj;
              if (date) minApplyDate = moment(date).format();
              this.setState({
                minApplyDate,
              });
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        }
      },
    );
  }

  GetleaveDetailsFromSelectedEmp(selectedItem) {
    this.setState(
      {
        employeeid: selectedItem ? selectedItem.displayvalue : null,
        SelectedEmpId: selectedItem ? selectedItem.displayvalue : null,
        SelectedEmpData: selectedItem,
        SelectedEmp: selectedItem,
        SelectedEmpData1: selectedItem,
        todayLeaveDate: new Date(),
      },
      () => {
        if (this.state.SelectedEmpId) {
          this.Getleavetypes();
          const url = `leaves/initleaveapply/${this.state.SelectedEmpId}`;
          instance
            .get(url)
            .then((result) => {
              let date = null;
              let minApplyDate = null;
              if (result.data.result[0]) date = result.data.result[0].doj;
              if (date) minApplyDate = moment(date).format();
              this.setState({
                minApplyDate,
                empdoj: minApplyDate,
                isleavepolicyassigned:
                  result.data.result[0] &&
                  result.data.result[0].isleavepolicyassigned,
              });
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        }
      },
    );
  }

  GetleaveDetailsFromSelectedEmp1(selectedItem) {
    this.setState(
      {
        SelectedEmpId: selectedItem ? selectedItem.displayvalue : null,
        employeeid: selectedItem ? selectedItem.displayvalue : null,
        SelectedEmpData: selectedItem,
        SelectedEmpData1: selectedItem,
        todayLeaveDate: new Date(),
      },
      () => {
        if (this.state.SelectedEmpId) {
          this.Getleavetypes();
          const url = `leaves/initleaveapply/${this.state.SelectedEmpId}`;
          instance
            .get(url)
            .then((result) => {
              let date = null;
              let minApplyDate = null;
              if (result.data.result[0]) date = result.data.result[0].doj;
              if (date) minApplyDate = moment(date).format();
              this.setState({
                minApplyDate,
                empdoj: minApplyDate,
                isleavepolicyassigned:
                  result.data.result[0] &&
                  result.data.result[0].isleavepolicyassigned,
              });
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        }
      },
    );
  }

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max) ||
        Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value });
    }
  };

  ApplyGiftLeave() {
    if (this.state.leavecount == 0) {
      this.props.enqueueSnackbar("Please add number of days", {
        variant: "error",
      });
    } else if (this.state.comment == null) {
      this.props.enqueueSnackbar("Please add message", { variant: "error" });
    } else if (
      this.state.SelectedEmpId == null ||
      this.state.SelectedEmp == null
    ) {
      this.props.enqueueSnackbar("Please add employee", { variant: "error" });
    } else {
      const employeeinfo = this.props.AuthenticationAction.login;
      const data = {
        senderid: employeeinfo.employeeid,
        giftedbyempid: employeeinfo.employeeid,
        sendersourceid: 1,
        leaverequesttypeid: 3,
        giftedbyleavepolicyid:
          this.state.giftpolicyDetail.giftedbyleavepolicyid,
        giftedbyleaveid: this.state.giftpolicyDetail.giftedbyleaveid,
        giftedbyleavetypeid: this.state.giftpolicyDetail.giftedbyleavetypeid,
        giftedbyleavecategoryid:
          this.state.giftpolicyDetail.giftedbyleavecategoryid,
        employeeid: this.getEmpId(),
        leavepolicyid: null,
        leaveid: null,
        leavetypeid: null,
        leavecategoryid: null,
        leavecount: this.state.leavecount,
        monthid: new Date().getMonth() + 1,
        gifteddate: convertDateForBackend(new Date()),
        comment: this.state.comment,
        recipient: this.state.recipient,
      };
      instance
        .post("leaves/applygiftleave", data)
        .then(() => {
          this.props.enqueueSnackbar("Gift leave applied successfully", {
            variant: "success",
          });
          this.setState({ leavecount: 0 });
          this.toggleDrawer("right", false);
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  UpdateLeaveId(selectedItem) {
    this.setState({
      selectedLeave: selectedItem,
    });
  }

  UpdateLeaveId1(selectedItem) {
    this.setState({
      selectedLeave1: selectedItem,
    });
  }

  UpdateComment(txt) {
    this.setState({ comment: txt.target.value });
  }

  getEmpId = () =>
    this.state.SelectedEmpId ||
    get(this.state, "SelectedEmpData.displayvalue", "") ||
    get(this.props, "AuthenticationAction.login.employeeid", "");

  Getleavetypesforsomeonelse() {
    const data = {
      tilldate: convertDateForBackend(this.state.todayLeaveDate),
      leavetypeids: null,
      // leavecycledurationid: leavecycledurationid
      employeeid:
        this.state.SelectedEmpId ||
        get(this.state, "SelectedEmpData.displayvalue", "") ||
        get(this.props, "AuthenticationAction.login.employeeid", ""),
      // employeeid: this.state.SelectedEmp.displayvalue
    };
    this.setState({ boolIsLoader: true });
    instance
      .post("leaves/leavebalance", data)
      .then((result) => {
        let defaultstate = false;
        if (result.data.result.length <= 0) {
          defaultstate = true;
        }
        this.setState(
          {
            boolIsLoader: false,
            Leavetypeslist1: result.data.result.filter(
              (res) =>
                res.active != 0 &&
                res.isdisable == false &&
                res.isrestrictinprobation == false,
            ),
            defaultstate,
            selectedLeave: result.data.result.filter(
              (res) => res.active != 0 && res.isdisable == false,
            )[0],
            selectedLeave1: result.data.result.filter(
              (res) => res.active != 0 && res.isdisable == false,
            )[0],
          },
          () => {
            if (this.state.Leavetypeslist1.length <= 0) {
              this.props.enqueueSnackbar(
                "Leave Policy is not Assigned. Please assign policy",
                {
                  variant: "error",
                },
              );
            } else {
              this.GetleaveRequest();
              this.GetLeaveCycle();
            }
          },
        );
      })
      .catch((error) => {
        this.setState({ boolIsLoader: false });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  async Getleavetypes(value) {
    let cycle = [];
    if (this.state.leaveCycleList > 0) {
      cycle = this.state.leaveCycleList;
    } else {
      const res = await instance.get("/leaves/subscriptionleavecycle");
      cycle = res.data.result;
    }
    const currentcycle = cycle.find(
      (x) =>
        x.leavecyclestartdate <=
          convertDateForBackend(this.state.todayLeaveDate) &&
        x.leavecycleenddate >= convertDateForBackend(this.state.todayLeaveDate),
    );
    this.setState({ displaymonthvaluedata: currentcycle });
    // console.log("currentcycle: ", currentcycle);
    const data = {
      tilldate: convertDateForBackend(this.state.todayLeaveDate),
      leavetypeids: null,
      leavecycledurationid: currentcycle
        ? currentcycle.leavecycledurationid
        : null,
      employeeid:
        this.state.SelectedEmpId ||
        get(this.state, "SelectedEmpData.displayvalue", "") ||
        get(this.props, "AuthenticationAction.login.employeeid", ""),
      // employeeid: this.state.SelectedEmpData && this.state.SelectedEmpData.displayvalue
    };
    this.setState({ boolIsLoader: true });
    instance
      .post("leaves/leavebalance", data)
      .then((result) => {
        if (result.data.result.length <= 0) {
          this.setState({ defaultstate: true });
        } else {
          this.setState(
            {
              boolIsLoader: false,
              Leavetypeslist: result.data.result,
              filterLeaveTypes: result.data.result.filter(
                (res) =>
                  res.active != 0 &&
                  res.isdisable == false &&
                  res.isrestrictinprobation == false,
              ),
              defaultstate: false,
            },
            () => {
              this.GetleaveRequest();
              this.GetLeaveCycle(value);
            },
          );
        }
      })
      .catch((error) => {
        this.setState({ boolIsLoader: false });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetleaveRequest() {
    const data = {
      fromdate: moment(this.state.SelectedMonth)
        .startOf("month")
        .format("YYYY-MM-DD"),
      todate: moment(this.state.SelectedMonth)
        .endOf("month")
        .format("YYYY-MM-DD"),
      employeeid:
        this.state.SelectedEmpId ||
        get(this.props, "AuthenticationAction.login.employeeid", ""),
    };
    instance
      .post("leaves/leaverequestbydate", data)
      .then((result) => {
        this.setState({ leaveRequest: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  async GetleaveHistory(value) {
    const isapicall = value;
    const cycle = [];
    // console.log("this.state.leaveCycleList: ", this.state.leavecycleduration);
    // if (this.state.leaveCycleList > 0) {
    //   cycle = this.state.leaveCycleList;
    // } else {
    //   const res = await instance.get("/leaves/subscriptionleavecycle");
    //   cycle = res.data.result;
    // }

    // const currentcycle = cycle.find(
    //   (x) =>
    //     x.leavecyclestartdate <=
    //     convertDateForBackend(this.state.todayLeaveDate) &&
    //     x.leavecycleenddate >= convertDateForBackend(this.state.todayLeaveDate),
    // );
    // console.log("isapicall: ", value);
    const data = {
      fromdate: moment(this.state.leavecycleduration.leavecyclestartdate)
        .startOf("month")
        .format("YYYY-MM-DD"),
      todate: moment(this.state.leavecycleduration.leavecycleenddate)
        .endOf("month")
        .format("YYYY-MM-DD"),
      employeeid:
        this.state.SelectedEmpId ||
        get(this.props, "AuthenticationAction.login.employeeid", ""),
      leavecycledurationid: this.state.leavecycleduration.leavecycledurationid,
    };
    if (value == false || value == null) {
      instance
        .post("leaves/leavehistorforleavecycle", data)
        .then((result) => {
          const leaveHistory = result.data.result;
          const groupedLeave = _.groupBy(leaveHistory, "leavetypename");
          const leaveList = [];
          _.each(groupedLeave, (leaveData, key) => {
            const leave = {
              summation: "",
              leavetypename: key,
              leavemonth: "",
              leaveid: leaveData[0].leaveid,
              leavetypeid: leaveData[0].leavetypeid,
            };
            leaveList.push(leave);
          });
          this.setState({ leaveHistory, leaveList });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  Getleavelogs() {
    const startOfMonth = moment(this.state.todayLeaveDate, "YYYY-MM-DD")
      .startOf("month")
      .format("YYYY-MM-DD");
    const endOfMonth = moment(this.state.todayLeaveDate, "YYYY-MM-DD")
      .endOf("month")
      .format("YYYY-MM-DD");
    const data = {
      fromdate: startOfMonth,
      todate: endOfMonth,
      leaveids: this.state.selectedLeave.leaveid.toString(),
      employeeid: this.state.SelectedEmpId || this.state.employeeid,
      leavetypeids: this.state.selectedLeave.leavetypeid.toString(),
    };
    instance
      .post("leaves/leaverequestbydate", data)
      .then((result) => {
        this.setState({ leaveLogs: result.data.result, isvisible: true });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  AllSubEmployee() {
    const data = {
      accountid: this.state.accountid,
      subscriptionid: this.state.subscriptionid,
      statusid: 1,
      featurekey: "leaveBalanceAndHistory",
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        let AllSubEmployee = result.data.result;
        AllSubEmployee = AllSubEmployee.filter(
          (x) =>
            x.displayvalue != this.props.AuthenticationAction.login.employeeid,
        );
        this.setState({ AllSubEmployee });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetEmployeeDetails = () => {
    const data = {
      featurekey: "leaveBalanceAndHistory",
      workflowfortypeid: 3,
    };
    instance
      .post(`attendance/approverreportee`, data)
      .then((result) => {
        const arrAllEmp = result.data.result;
        const opt = [];
        opt.push({
          label: "Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 1,
          ),
        });

        opt.push({
          label: "In-Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 3,
          ),
        });

        this.setState({ empList: opt });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  GetApproverList = () => {
    const data = {
      workflowfortypeid: 3,
      withadmin: true,
      employeeid:
        this.state.SelectedEmpId ||
        get(this.state, "SelectedEmpData.displayvalue", "") ||
        get(this.props, "AuthenticationAction.login.employeeid", ""),
      // employeeid: this.state.SelectedEmpId
    };
    instance
      .post("leaves/employeeapprovalrecipients", data)
      .then((result) => {
        let recipient = [];
        for (const approver of result.data.result) {
          const approverObj = {
            approveremployeeid: approver.employeeid,
            levelid: approver.levelid,
          };
          recipient.push(approverObj);
        }
        if (recipient.length < 0) recipient = null;
        this.setState({ recipient, originalrecipients: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  SearchEmployee = (search) => {
    if (search.length < 1) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 0
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: null,
        featurekey: "leaveBalanceAndHistory",
      };
      instance
        .post(URL, data)
        .then((result) => {
          const arrAllEmp = result.data.result;
          const opt = [];
          opt.push({
            label: "Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 1,
            ),
          });

          opt.push({
            label: "In-Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 3,
            ),
          });

          this.setState({ emplist: opt });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  GetLeaveCycle(value) {
    // console.log("yups");
    instance
      .get("/leaves/subscriptionleavecycle")
      .then((result) => {
        if (result.data.result.length > 0) {
          for (const leave of result.data.result) {
            leave.displayvalue = leave.leavecycledurationid;
          }
          let leaveCycleList = [];
          let leavecycleduration = {};
          leaveCycleList = result.data.result;
          // leavecycleduration = result.data.result.find(
          //   (x) => x.year == new Date().getFullYear(),
          // );
          leavecycleduration = result.data.result.find(
            (x) => x.leavecycletypeid == 2,
          );
          let displaymonthvaluedata = null;
          displaymonthvaluedata = result.data.result.find(
            (x) =>
              x.leavecyclestartdate <=
                convertDateForBackend(this.state.todayLeaveDate) &&
              x.leavecycleenddate >=
                convertDateForBackend(this.state.todayLeaveDate),
          );
          // console.log('displaymonthvaluedata: ', displaymonthvaluedata);
          this.setState(
            { leaveCycleList, leavecycleduration, displaymonthvaluedata },
            () => {
              this.getMonths(
                this.state.leavecycleduration.leavecyclestartdate,
                this.state.leavecycleduration.leavecycleenddate,
                value,
              );
            },
          );
        } else {
          this.props.enqueueSnackbar("Please create a Leave Cycle", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  ConvertDate(str) {
    return str;
    // const date = new Date(str);
    // const mnth = `0${date.getMonth() + 1}`.slice(-2);
    // const day = `0${date.getDate()}`.slice(-2);
    // return [date.getFullYear(), mnth, day].join("-");
  }

  selectDate(args) {
    // if (this.state.Leavetypeslist.length > 0) {
    // let date = this.ConvertDate(args.value);
    let date = args.value;
    const currentdate = moment(new Date()).format("MM");
    const selecetdmonth = moment(date).endOf("month").format("MM");
    const currentyear = moment(new Date()).format("YYYY");
    const selecetdyear = moment(date).endOf("month").format("YYYY");
    if (selecetdmonth == currentdate) {
      if (currentyear == selecetdyear) {
        date = moment(new Date()).format("YYYY-MM-DD");
      } else {
        date = moment(date).endOf("month").format("YYYY-MM-DD");
      }
    } else {
      date = moment(date).endOf("month").format("YYYY-MM-DD");
    }
    if (date != this.state.todayLeaveDate) {
      const todayLeaveDate = date;
      let date1 = {};
      this.state.leaveCycleList.filter((x) => {
        const newdate = moment(date).format("YYYY-MM-DD");
        const startingdate = moment(x.leavecyclestartdate).format("YYYY-MM-DD");
        const endingdate = moment(x.leavecycleenddate).format("YYYY-MM-DD");
        if (startingdate <= newdate && newdate <= endingdate) {
          date1 = x;
        }
      });
      this.setState({ todayLeaveDate }, () => {
        this.Getleavetypes(true);
        this.leaveCycleOnChange(date1);
      });
    }
    // }
  }

  SelectfromDate(args) {
    let date = this.ConvertDate(args.value);
    let fromdatetime = date;
    if (Number(this.state.selectedLeave.leavetypeid) == 3) {
      const todatetime = date;
      this.setState({ fromdatetime, todatetime });
    } else {
      date = this.ConvertDate(args.value);
      fromdatetime = date;
      const todatetime = date;
      if (this.state.selecteddaytype == 1) {
        this.setState({ fromdatetime, todatetime });
      } else {
        this.setState({ fromdatetime });
      }
    }
  }

  SelecttoDate(args) {
    const date = this.ConvertDate(args.value);
    const todatetime = date;
    this.setState({ todatetime });
  }

  updateFromTime(args) {
    const fromtime = args.target.value;
    this.setState({ fromtime });
  }

  updateToTome(args) {
    const totime = args.target.value;
    this.setState({ totime });
  }

  onChangeDayType(event) {
    this.setState({
      selecteddaytype: parseInt(event.target.value),
      leavestarttypeid: 1,
      leaveendtypeid: 1,
      fromdatetime: "",
      todatetime: "",
    });
  }

  changeleavetype(event) {
    this.setState({
      leaveendtypeid: parseInt(event.target.value),
      leavestarttypeid: parseInt(event.target.value),
    });
  }

  changeendleavetype(event) {
    this.setState({
      leaveendtypeid: parseInt(event.target.value),
    });
  }

  changestartleavetype(event) {
    this.setState({
      leavestarttypeid: parseInt(event.target.value),
    });
  }

  getMonths(dateStart, dateEnd, value) {
    dateStart = moment(dateStart);
    dateEnd = moment(dateEnd);
    const monthList = [];
    const monthArry = [];
    while (
      dateEnd > dateStart ||
      dateStart.format("M") === dateEnd.format("M")
    ) {
      monthList.push({
        monthName: dateStart.format("MMM"),
        monthValue: Number(dateStart.format("MM")),
        year: dateStart.format("YYYY"),
      });
      monthArry.push(Number(dateStart.format("MM")));
      dateStart.add(1, "month");
    }
    this.setState({ monthList, monthArry }, () => {
      this.GetleaveHistory(value);
    });
  }

  leaveCycleOnChange = (val) => {
    this.setState({ leavecycleduration: val }, () => {
      this.getMonths(
        this.state.leavecycleduration.leavecyclestartdate,
        this.state.leavecycleduration.leavecycleenddate,
      );
    });
  };

  removeImage() {
    this.setState({
      imgname: "",
      file: null,
    });
  }

  Validate = () => {
    if (this.state.value == 0) {
      if (!this.state.selectedLeave) {
        this.props.enqueueSnackbar("Please select a Leave Type", {
          variant: "error",
        });
      } else if (!this.state.fromdatetime) {
        this.props.enqueueSnackbar(
          this.state.selecteddaytype == 2
            ? "Please select from date"
            : this.state.selecteddaytype == 1 && "Please select date",
          {
            variant: "error",
          },
        );
      } else if (!this.state.todatetime) {
        this.props.enqueueSnackbar("Please select to date", {
          variant: "error",
        });
      } else if (!this.state.comment) {
        this.props.enqueueSnackbar("Please add comment", { variant: "error" });
      } else if (this.state.value == 1 && !this.state.SelectedEmp) {
        this.props.enqueueSnackbar(
          "Please select whom you wish to apply a leave for",
          {
            variant: "error",
          },
        );
      } else if (
        Number(this.state.selectedLeave.leavetypeid) == 3 &&
        !this.state.fromtime
      ) {
        this.props.enqueueSnackbar("Please select from time", {
          variant: "error",
        });
      } else if (
        Number(this.state.selectedLeave.leavetypeid) == 3 &&
        !this.state.totime
      ) {
        this.props.enqueueSnackbar("Please select to time", {
          variant: "error",
        });
      } else if (this.state.errors.ProfileImg == true) {
        this.props.enqueueSnackbar("Please select a valid file", {
          variant: "error",
        });
      } else if (
        (this.state.recipient && this.state.recipient.length == 0) ||
        !this.state.recipient
      ) {
        this.props.enqueueSnackbar(
          "Something went wrong please try again later",
          {
            variant: "error",
          },
        );
      } else return true;
    } else if (this.state.value == 1) {
      if (!this.state.selectedLeave1) {
        this.props.enqueueSnackbar("Please select a Leave Type", {
          variant: "error",
        });
      } else if (!this.state.fromdatetime) {
        this.props.enqueueSnackbar(
          this.state.selecteddaytype == 2
            ? "Please select from date"
            : this.state.selecteddaytype == 1 && "Please select date",
          {
            variant: "error",
          },
        );
      } else if (!this.state.todatetime) {
        this.props.enqueueSnackbar("Please select to date", {
          variant: "error",
        });
      } else if (!this.state.comment) {
        this.props.enqueueSnackbar("Please add comment", { variant: "error" });
      } else if (this.state.value == 1 && !this.state.SelectedEmp) {
        this.props.enqueueSnackbar(
          "Please select whom you wish to apply a leave for",
          {
            variant: "error",
          },
        );
      } else if (
        Number(this.state.selectedLeave1.leavetypeid) == 3 &&
        !this.state.fromtime
      ) {
        this.props.enqueueSnackbar("Please select from time", {
          variant: "error",
        });
      } else if (
        Number(this.state.selectedLeave1.leavetypeid) == 3 &&
        !this.state.totime
      ) {
        this.props.enqueueSnackbar("Please select to time", {
          variant: "error",
        });
      } else if (this.state.errors.ProfileImg == true) {
        this.props.enqueueSnackbar("Please select a valid file", {
          variant: "error",
        });
      } else if (
        (this.state.recipient && this.state.recipient.length == 0) ||
        !this.state.recipient
      ) {
        this.props.enqueueSnackbar(
          "Something went wrong please try again later",
          {
            variant: "error",
          },
        );
      } else return true;
    }
  };

  cleardrawerData() {
    this.setState({
      leaveLogs: [],
      right: false,
      isvisible: false,
      fromdatetime: "",
    });
  }

  ApplyLeave() {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    if (!issaveinprogress) {
      if (this.Validate()) {
        let { fromdatetime } = this.state;
        let { todatetime } = this.state;
        const fromd = new Date(fromdatetime);
        const tod = new Date(todatetime);
        if (fromd > tod) {
          this.props.enqueueSnackbar(
            "From Time cannot be greater than To Time",
            {
              variant: "error",
            },
          );
          return false;
        }
        if (this.state.value == 0 || this.state.value == 1) {
          if (Number(this.state.selectedLeave1.leavetypeid) == 3) {
            const fromdate = moment(fromdatetime).format("YYYY-MM-DD");
            const todate = moment(todatetime).format("YYYY-MM-DD");
            fromdatetime = moment(
              `${fromdate} ${this.state.fromtime}:00`,
              "YYYY-MM-DD HH:mm:ss",
            ).format("YYYY-MM-DD HH:mm:ss");
            todatetime = moment(
              `${todate} ${this.state.totime}:00`,
              "YYYY-MM-DD HH:mm:ss",
            ).format("YYYY-MM-DD HH:mm:ss");
          } else {
            fromdatetime = moment(fromdatetime).format("YYYY-MM-DD HH:mm:ss");
            todatetime = moment(todatetime).format("YYYY-MM-DD HH:mm:ss");
          }
        }
        let data;
        if (this.state.value == 0) {
          data = {
            employeeid: this.state.SelectedEmpId || this.state.employeeid,
            senderid: this.state.senderid,
            sendersourceid: 1,
            leavepolicyid: this.state.selectedLeave.leavepolicyid,
            leaveid: this.state.selectedLeave.leaveid,
            leavetypeid: Number(this.state.selectedLeave.leavetypeid),
            leavecategoryid: Number(this.state.selectedLeave.leavecategoryid),
            fromdatetime,
            todatetime,
            leavestarttypeid: Number(this.state.leavestarttypeid),
            leaveendtypeid: Number(this.state.leaveendtypeid),
            comment: this.state.comment,
            attachmenturl: this.state.imgname,
            recipient: this.state.recipient,
            additionalrecipient: this.state.empTaglist
              ? this.state.empTaglist.join()
              : null,
          };
        } else if (this.state.value == 1) {
          data = {
            // employeeid: this.state.SelectedEmpId,
            employeeid:
              this.state.SelectedEmpId ||
              get(this.state, "SelectedEmpData.displayvalue", "") ||
              get(this.props, "AuthenticationAction.login.employeeid", ""),
            senderid: this.state.senderid,
            sendersourceid: 1,
            leavepolicyid:
              this.state.selectedLeave1.leavepolicyid ||
              this.state.selectedLeave.leavepolicyid,
            leaveid:
              this.state.selectedLeave1.leaveid ||
              this.state.selectedLeave.leaveid,
            leavetypeid:
              Number(this.state.selectedLeave1.leavetypeid) ||
              Number(this.state.selectedLeave.leavetypeid),
            leavecategoryid:
              Number(this.state.selectedLeave1.leavecategoryid) ||
              Number(this.state.selectedLeave.leavecategoryid),
            fromdatetime,
            todatetime,
            leavestarttypeid: Number(this.state.leavestarttypeid),
            leaveendtypeid: Number(this.state.leaveendtypeid),
            comment: this.state.comment,
            attachmenturl: this.state.imgname,
            recipient: this.state.recipient,
            additionalrecipient: this.state.empTaglist
              ? this.state.empTaglist.join()
              : null,
          };
        }
        this.props.setSaveProgress(true);
        instance
          .post("leaves/applyleave", data)
          .then((result) => {
            this.imageUpload(
              result.data.result[0].leaverequestid,
              data.employeeid,
            );
            this.setState(
              {
                giftLeave: false,
                applyLeave: false,
                viewLogs: false,
                right: false,
                ledger: false,
              },
              () => {
                this.ClearState();
                this.Getleavetypes();
                this.GetleaveRequest();
                this.props.removeSaveProgress();
                this.GetLeaveCycle();
              },
            );
          })
          .catch((error) => {
            this.props.removeSaveProgress();
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    }
  }

  imageUpload(leaverequestid, employeeid) {
    const formData = new FormData();
    if (this.state.file) {
      formData.append("file", this.state.file);
      instanceMultipart
        .post(
          `/subscription/leavesupload/${leaverequestid}/${employeeid}`,
          formData,
        )
        .then(() => {
          this.props.enqueueSnackbar("Leave applied successfully", {
            variant: "success",
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Leave applied successfully", {
        variant: "success",
      });
    }
    this.toggleDrawer("right", false);
  }

  getFiles1(files) {
    const file = files[0];
    const formData = new FormData();
    // if (get(this.props, "AuthenticationAction.IsFulfilled", "")) {
    //   formData.append("file", file);
    // } else {
    //   formData.append("file", file);
    // }
    formData.append("file", file);
    if (files.length == 0) {
      this.props.enqueueSnackbar("Please select Valid image. (Maxsize : 2MB)", {
        variant: "error",
      });
      return false;
    }
    let extFile = "";
    const imgname = file.name;
    let idxDot = "";
    idxDot = imgname.lastIndexOf(".") + 1;
    extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    if (file.size > 2097152) {
      this.props.enqueueSnackbar(
        "Please Upload Valid Size Image (Maxsize : 2MB)",
        {
          variant: "error",
        },
      );
      this.setState({ file: null, imgname: "" });
    } else if (
      !(
        extFile == "png" ||
        extFile == "jpg" ||
        extFile == "jpeg" ||
        extFile == "pdf" ||
        extFile == "docx" ||
        extFile == "xlsx"
      )
    ) {
      this.props.enqueueSnackbar("Please Upload valid file", {
        variant: "error",
      });
      const { errors } = this.state;
      errors.ProfileImg = true;
      this.setState({
        img: null,
        errors,
        file: null,
        imgname: null,
        idxDot: null,
        extFile: null,
      });
      return null;
    } else {
      this.setState({
        file,
        imgname: file.name,
      });
    }
  }

  showLeavePolicy(leaveoption) {
    this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
      ...this.props.InitLeavesPolicy,
      leavepolicyid: leaveoption.leavepolicyid,
      isdraft: false,
      isviewmode: true,
      leaveid: leaveoption.leaveid,
      leavetypeid: leaveoption.leavetypeid,
    });
    this.props.history.push("policy/create");
  }

  render() {
    const { classes } = this.props;
    const { value, SelectedEmpData, isFromModule, onetime, defaultstate } =
      this.state;

    const startOfMonth = moment(this.state.todayLeaveDate, "YYYY-MM-DD")
      .startOf("month")
      .format("YYYY-MM-DD");
    const endOfMonth = moment(this.state.todayLeaveDate, "YYYY-MM-DD")
      .endOf("month")
      .format("YYYY-MM-DD");
    const language = this.props.Language.leavebalance;

    const applyLeave = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.applyLeave,
    );
    const annualLeaveHistory =
      this.props.AuthenticationAction.login.features.find(
        (feature) => feature.featureid == FEATUREKEYS.annualLeaveHistory,
      );
    const migrateleave = this.props.AuthenticationAction.login.migration.find(
      (x) => x.moduletypeid == 2,
    );
    // console.log("migratattendance: ", migrateleave);
    return (
      <div className="application">
        {isFromModule ? (
          <Helmet>
            <meta charSet="utf-8" />
            <title>{headersList.Leave.StartLeaves.header}</title>
          </Helmet>
        ) : (
          <Helmet>
            <meta charSet="utf-8" />
            <title>{headersList.Leave.Leaves.header}</title>
          </Helmet>
        )}
        <IntlProvider locale="en" messages={language}>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <main
              className={
                isFromModule
                  ? "content-outer-wrapper-with-tab"
                  : "content-outer-wrapper"
              }
            >
              {this.state.isleavepolicyassigned == false ? (
                <Grid container>
                  <Grid item xs={12} md={12} sm={12} className="position-rel">
                    {!isFromModule && migrateleave && migrateleave.isenable && (
                      <div
                        style={{
                          float: "right",
                          width: 220,
                          marginTop: 8,
                          color: "#057cff",
                          fontWeight: 400,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          window.open(migrateleave.oldurl);
                        }}
                      >
                        View leave in sumHR 2.0
                      </div>
                    )}
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ height: !isFromModule && 30 }}
                      >
                        {isFromModule && (
                          <span>
                            <span className="floatleft margin-right-16">
                              {isFromModule &&
                                (this.state.masterprofileid == 9 ? (
                                  <Select
                                    className="selectsearch inlindClass width250"
                                    onChange={this.GetleaveDetailsFromSelectedEmp.bind(
                                      this,
                                    )}
                                    onInputChange={this.SearchEmployee}
                                    options={this.state.emplist}
                                    getOptionLabel={(option) =>
                                      option.displayname
                                    }
                                    getOptionValue={(option) =>
                                      option.displayvalue
                                    }
                                    value={this.state.SelectedEmpData}
                                    placeholder="Search Employee"
                                    isClearable={true}
                                  />
                                ) : (
                                  this.state.empList &&
                                  this.state.empList.length > 0 && (
                                    <Select
                                      className="selectsearch width250"
                                      onChange={this.GetleaveDetailsFromSelectedEmp1.bind(
                                        this,
                                      )}
                                      options={this.state.empList}
                                      getOptionLabel={(option) =>
                                        option.displayname
                                      }
                                      getOptionValue={(option) =>
                                        option.displayvalue
                                      }
                                      value={this.state.SelectedEmpData}
                                      placeholder="Select Employee"
                                    />
                                  )
                                ))}
                            </span>
                            <span className="floatleft width75">
                              {this.state.SelectedEmpData && !defaultstate ? (
                                <CallOutNew
                                  classnames="bg-light-blue width100"
                                  header={`Leaves data (calculated from joining date) of the selected employee is displayed below. ${this.state.SelectedEmpData.displayname.substr(
                                    0,
                                    this.state.SelectedEmpData.displayname.indexOf(
                                      " ",
                                    ),
                                  )}'s joining date is ${getFormattedDate(
                                    this.state.empdoj,
                                  )}.`}
                                  emoji="🔍 👩🏻‍💼 🏖"
                                  textcolor="#1e8ced"
                                />
                              ) : (
                                <CallOutNew
                                  classnames="bg-light-blue width100"
                                  header="Search and select the employee whose leave balance you wish to see."
                                  emoji="🔍 👩🏻‍💼 🏖"
                                  textcolor="#1e8ced"
                                />
                              )}
                            </span>
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <DefaultComp
                      heading="There is no policy assigned yet!"
                      subheading="You can only view leave balance after a policy has been assigned"
                      imageSrc={defaultstateimg}
                      permissions={this.state.permissions}
                    />
                  </Grid>
                </Grid>
              ) : (
                <>
                  <div
                    className="display-flex"
                    style={{
                      justifyContent: "space-between",
                    }}
                  >
                    {/* <PageHeader
                        header={
                          isFromModule
                            ? "Employee leave data"
                            : "My leave balance"
                        }
                      /> */}
                    <span className="large-text-dark t-bold">
                      {" "}
                      {isFromModule
                        ? "Employee leave data"
                        : "My leave balance"}
                    </span>
                    <DatePickerComponent
                      className="leave-history-year-selector floatright t-14 margin-bottom-16"
                      format={getEJ2CalenderMonthFormat()}
                      hideClearIcon
                      allowEdit={false}
                      start="Decade"
                      depth="Year"
                      width="width200"
                      disabled={!SelectedEmpData && isFromModule}
                      min={
                        this.state.minApplyDate >
                        (this.state.leaveCycleList[0] &&
                          this.state.leaveCycleList[0].leavecyclestartdate)
                          ? this.state.minApplyDate
                          : this.state.leaveCycleList[0] &&
                            this.state.leaveCycleList[0].leavecyclestartdate
                      }
                      max={
                        this.state.leavecycleduration &&
                        this.state.leavecycleduration.leavecycleenddate
                      }
                      change={
                        !isFromModule
                          ? this.selectDate
                          : isFromModule && SelectedEmpData && this.selectDate
                      }
                      value={this.state.todayLeaveDate}
                    />
                  </div>
                  {!defaultstate || isFromModule ? (
                    <div>
                      <div>
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{ height: !isFromModule && 30 }}
                          >
                            {isFromModule && (
                              <span>
                                <span className="floatleft margin-right-16">
                                  {isFromModule &&
                                    (this.state.masterprofileid == 9 ? (
                                      <Select
                                        className="selectsearch inlindClass width250"
                                        onChange={this.GetleaveDetailsFromSelectedEmp.bind(
                                          this,
                                        )}
                                        onInputChange={this.SearchEmployee}
                                        options={this.state.emplist}
                                        getOptionLabel={(option) =>
                                          option.displayname
                                        }
                                        getOptionValue={(option) =>
                                          option.displayvalue
                                        }
                                        value={this.state.SelectedEmpData}
                                        placeholder="Search Employee"
                                        isClearable={true}
                                      />
                                    ) : (
                                      this.state.empList &&
                                      this.state.empList.length > 0 && (
                                        <Select
                                          className="selectsearch width250"
                                          onChange={this.GetleaveDetailsFromSelectedEmp1.bind(
                                            this,
                                          )}
                                          options={this.state.empList}
                                          getOptionLabel={(option) =>
                                            option.displayname
                                          }
                                          getOptionValue={(option) =>
                                            option.displayvalue
                                          }
                                          value={this.state.SelectedEmpData}
                                          placeholder="Select Employee"
                                        />
                                      )
                                    ))}
                                </span>
                                <span className="floatleft width75">
                                  {this.state.SelectedEmpData &&
                                  !defaultstate ? (
                                    <CallOutNew
                                      classnames="bg-light-blue width100"
                                      header={`Leaves data (calculated from joining date) of the selected employee is displayed below. ${this.state.SelectedEmpData.displayname.substr(
                                        0,
                                        this.state.SelectedEmpData.displayname.indexOf(
                                          " ",
                                        ),
                                      )}'s joining date is ${getFormattedDate(
                                        this.state.empdoj,
                                      )}.`}
                                      emoji="🔍 👩🏻‍💼 🏖"
                                      textcolor="#1e8ced"
                                    />
                                  ) : (
                                    <CallOutNew
                                      classnames="bg-light-blue width100"
                                      header="Search and select the employee whose leave balance you wish to see."
                                      emoji="🔍 👩🏻‍💼 🏖"
                                      textcolor="#1e8ced"
                                    />
                                  )}
                                </span>
                              </span>
                            )}
                          </Grid>
                        </Grid>
                        {this.state.boolIsLoader ? (
                          <img className="loader" src={loader} />
                        ) : (
                          <div>
                            {(SelectedEmpData || !isFromModule) &&
                              !defaultstate && (
                                <div
                                  style={{
                                    float: "right",
                                    marginTop: isFromModule ? "16px" : "-16px",
                                  }}
                                >
                                  {!isFromModule &&
                                    migrateleave &&
                                    migrateleave.isenable && (
                                      <div
                                        style={{
                                          float: "left",
                                          width: 220,
                                          marginTop: 8,
                                          color: "#057cff",
                                          fontWeight: 400,
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          window.open(migrateleave.oldurl);
                                        }}
                                      >
                                        View leave in sumHR 2.0
                                      </div>
                                    )}
                                </div>
                              )}

                            {(SelectedEmpData || !isFromModule) &&
                              !defaultstate && (
                                <Grid container>
                                  {this.state.Leavetypeslist.map(
                                    (leaveoption) => (
                                      <LeaveTypeWidget
                                        key="key"
                                        {...this.state}
                                        {...this.props}
                                        leaveoption={leaveoption}
                                        toggleDrawer={this.toggleDrawer}
                                        showLeavePolicy={this.showLeavePolicy}
                                        applyLeave={applyLeave}
                                        isFromModule={isFromModule}
                                      />
                                    ),
                                  )}
                                </Grid>
                              )}

                            {!defaultstate &&
                              annualLeaveHistory &&
                              annualLeaveHistory.actionid != 3 &&
                              (SelectedEmpData || !isFromModule) && (
                                <div className="margin-top-20">
                                  <div className="padding-bottom-20 padding-top-20">
                                    <span className="leaveBalance-title">
                                      Leave History
                                    </span>
                                    <Select
                                      className="inlindClass width40 margin-left-20 leave-history-year-selector t-14"
                                      onChange={this.leaveCycleOnChange.bind(
                                        this,
                                      )}
                                      options={this.state.leaveCycleList}
                                      getOptionLabel={(option) =>
                                        option.displayname
                                      }
                                      getOptionValue={(option) =>
                                        option.displayvalue
                                      }
                                      value={this.state.leavecycleduration}
                                    />
                                  </div>
                                  <div className="margin-bottom-8">
                                    <Divider />
                                  </div>
                                  <Paper>
                                    <Grid container>
                                      <Grid
                                        item
                                        xs={12}
                                        md={2}
                                        sm={2}
                                        className="leaverequest-head"
                                      >
                                        <FormattedMessage
                                          id="LbLeavename"
                                          defaultMessage="Leave Name"
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={10} sm={10}>
                                        <Grid container>
                                          {this.state.monthList.map((data) => (
                                            <Grid
                                              key="key"
                                              item
                                              xs={12}
                                              md={1}
                                              sm={1}
                                              className="leaverequest-head text-center"
                                            >
                                              {data.monthName}
                                            </Grid>
                                          ))}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <div>
                                      {this.state.leaveList.length > 0 ? (
                                        this.state.leaveList.map((options) => (
                                          <Paper key="key" className="padding4">
                                            <Grid container>
                                              <Grid
                                                item
                                                xs={12}
                                                md={2}
                                                sm={2}
                                                className="cell-format"
                                              >
                                                <p className="margin-top-4">
                                                  {options.leavetypename}
                                                </p>
                                              </Grid>
                                              <Grid
                                                item
                                                xs={12}
                                                md={10}
                                                sm={10}
                                              >
                                                <Grid container>
                                                  {this.state.monthList.map(
                                                    (data) => {
                                                      const monthData = _.where(
                                                        this.state.leaveHistory,
                                                        {
                                                          leavemonth:
                                                            data.monthValue,
                                                          leaveid:
                                                            options.leaveid,
                                                        },
                                                      );
                                                      return (
                                                        <React.Fragment key="key">
                                                          {monthData.length >
                                                            0 &&
                                                          monthData[0]
                                                            .leavetypeid !=
                                                            3 ? (
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              md={1}
                                                              sm={1}
                                                              className="cell-format"
                                                            >
                                                              <p
                                                                className="t-14 text-center"
                                                                style={{
                                                                  marginTop: 15,
                                                                }}
                                                              >
                                                                <img
                                                                  src={Sun}
                                                                  height="14"
                                                                  style={{
                                                                    margin:
                                                                      "0 auto",
                                                                    display:
                                                                      "block",
                                                                  }}
                                                                />
                                                                <strong>
                                                                  {
                                                                    monthData[0]
                                                                      .summation
                                                                  }
                                                                </strong>
                                                              </p>
                                                            </Grid>
                                                          ) : monthData.length >
                                                              0 &&
                                                            monthData[0]
                                                              .leavetypeid ==
                                                              3 ? (
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              md={1}
                                                              sm={1}
                                                              className="cell-format"
                                                            >
                                                              <p
                                                                className="t-14 text-center"
                                                                style={{
                                                                  marginTop: 15,
                                                                }}
                                                              >
                                                                <img
                                                                  src={Clock}
                                                                  height="14"
                                                                  style={{
                                                                    margin:
                                                                      "0 auto",
                                                                    display:
                                                                      "block",
                                                                  }}
                                                                />
                                                                <strong>
                                                                  {
                                                                    monthData[0]
                                                                      .summation
                                                                  }
                                                                </strong>
                                                              </p>
                                                            </Grid>
                                                          ) : (
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              md={1}
                                                              sm={1}
                                                              className="cell-format"
                                                            />
                                                          )}
                                                        </React.Fragment>
                                                      );
                                                    },
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Paper>
                                        ))
                                      ) : (
                                        <Grid container>
                                          <div className="text-align-center padding10">
                                            <FormattedMessage
                                              id="LbNorecordfound"
                                              defaultMessage="No Record Found"
                                            />
                                          </div>
                                        </Grid>
                                      )}
                                    </div>
                                  </Paper>
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                      <Drawer
                        anchor="right"
                        open={this.state.right}
                        onClose={() => {
                          this.toggleDrawer("right", false);
                          this.cleardrawerData();
                        }}
                        classes={{
                          paper: classnames(
                            classes.drawerPaper,
                            "planner-drawer",
                            this.state.ledger ? "width100" : "width30",
                          ),
                        }}
                      >
                        <div>
                          <div
                            className={
                              this.state.ledger
                                ? "leavebalance-drawer-ledger"
                                : "leavebalance-drawer"
                            }
                          >
                            {this.state.giftLeave ? (
                              <div>
                                <DrawerHeader
                                  header={
                                    <FormattedMessage
                                      id="LbGiftleave"
                                      defaultMessage="Gift leave"
                                    />
                                  }
                                  isbackarrow={false}
                                  closeDrawer={() =>
                                    this.toggleDrawer("right", false)
                                  }
                                />

                                <div>
                                  <p className="input-label">
                                    <FormattedMessage
                                      id="__LbBeneficiaries"
                                      defaultMessage="Recipients"
                                    />
                                  </p>
                                  <div>
                                    {this.state.originalrecipients &&
                                    this.state.originalrecipients.length > 0 ? (
                                      <div className="team-member-profile position-rel">
                                        {this.state.originalrecipients.map(
                                          (emp) => (
                                            <Tooltip
                                              key="key"
                                              title={emp.employeename}
                                              placement="bottom"
                                            >
                                              <Link
                                                to={`../../../profile/${emp.employeeid}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <div className="inlineClass">
                                                  {emp.imagepath == null ? (
                                                    <img
                                                      src={defaultEmp}
                                                      height="50"
                                                      className="team-avatar"
                                                    />
                                                  ) : (
                                                    <img
                                                      src={getFormattedImageLink(
                                                        emp.imagepath,
                                                      )}
                                                      height="50"
                                                      className="team-avatar"
                                                    />
                                                  )}
                                                </div>
                                              </Link>
                                            </Tooltip>
                                          ),
                                        )}
                                      </div>
                                    ) : (
                                      <div className="padding-bottom-8">
                                        <FormattedMessage
                                          id="LbNorecipients"
                                          defaultMessage="No recipients available"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="padding-top-15">
                                  <p className="input-label">
                                    <FormattedMessage
                                      id="Lbselectemployee"
                                      defaultMessage="Select employee "
                                    />
                                  </p>
                                  <Select
                                    className="selectsearch width100"
                                    onChange={this.UpdateSelectedEmpId.bind(
                                      this,
                                    )}
                                    options={this.state.emplist}
                                    getOptionLabel={(option) =>
                                      option.displayname
                                    }
                                    getOptionValue={(option) =>
                                      option.displayvalue
                                    }
                                    onInputChange={this.SearchEmployee}
                                    value={this.state.SelectedEmp}
                                    placeholder="Enter employee name"
                                  />
                                </div>
                                <div className="padding-top-15">
                                  <div>
                                    <p className="input-label margin-bottom-0">
                                      <FormattedMessage
                                        id="LbNumberOfDays"
                                        defaultMessage="Number of days"
                                      />
                                    </p>
                                  </div>
                                  <span className="gift-leave-number">
                                    <InputValues
                                      min="0"
                                      max="100"
                                      field="leavecount"
                                      onChange={this.CommonNumberChange.bind(
                                        this,
                                        "leavecount",
                                        100,
                                      )}
                                      value={this.state.leavecount}
                                      defaultvalue={this.state.leavecount}
                                    />
                                  </span>
                                </div>
                                <div className="padding-top-4">
                                  <div>
                                    <p className="input-label">
                                      <FormattedMessage
                                        id="LbMessageforGiftee"
                                        defaultMessage="Message for beneficiary"
                                      />
                                    </p>
                                  </div>
                                  <TextArea
                                    className="width100"
                                    maxLength="550"
                                    onChange={this.UpdateComment.bind(this)}
                                    variant="outlined"
                                    multiline
                                  />
                                </div>
                                <div className="padding-top-30">
                                  <Button
                                    variant="contained"
                                    className="btn btn-primary-md-blue"
                                    onClick={this.ApplyGiftLeave.bind(this)}
                                  >
                                    <FormattedMessage
                                      id="LbGiftleave"
                                      defaultMessage="Gift Leave"
                                    />
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.applyLeave ? (
                              <div>
                                <DrawerHeader
                                  header={
                                    <FormattedMessage
                                      id="LbApplyleave"
                                      defaultMessage="Apply Leave"
                                    />
                                  }
                                  isbackarrow={false}
                                  closeDrawer={() =>
                                    this.toggleDrawer("right", false)
                                  }
                                />
                                <AppBar position="static" color="primary">
                                  <Tabs
                                    value={value}
                                    onChange={this.handleChange}
                                  >
                                    <Tab
                                      label="My Self"
                                      className="minwidth50"
                                    />
                                    <Tab
                                      label="Someone Else"
                                      className="minwidth50"
                                    />
                                  </Tabs>
                                </AppBar>
                                <TabContainer>
                                  <div className="margin-top-10">
                                    <div className="margin-top-16">
                                      {this.state.value == 1 && (
                                        <div className="position-rel">
                                          <p className="input-label">
                                            <FormattedMessage
                                              id="LbSelectEmployee"
                                              defaultMessage="Select employee"
                                            />
                                          </p>
                                          <div>
                                            {this.state.masterprofileid &&
                                            this.state.masterprofileid != 9 ? (
                                              <Select
                                                className="selectsearch width100"
                                                onChange={this.UpdateSelectedEmpId.bind(
                                                  this,
                                                )}
                                                options={this.state.empList}
                                                getOptionLabel={(option) =>
                                                  option.displayname
                                                }
                                                getOptionValue={(option) =>
                                                  option.displayvalue
                                                }
                                                value={
                                                  this.state.SelectedEmpData
                                                }
                                                placeholder="Select Employee"
                                              />
                                            ) : (
                                              <Select
                                                className="selectsearch width100"
                                                onInputChange={
                                                  this.SearchEmployee
                                                }
                                                onChange={this.UpdateSelectedEmpId.bind(
                                                  this,
                                                )}
                                                options={this.state.emplist}
                                                getOptionLabel={(option) =>
                                                  option.displayname
                                                }
                                                getOptionValue={(option) =>
                                                  option.displayvalue
                                                }
                                                value={
                                                  onetime
                                                    ? this.state.SelectedEmpData
                                                    : this.state.SelectedEmp
                                                }
                                                placeholder="Select Employee"
                                              />
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    {this.state.value == 1 ? (
                                      <div className="margin-top-10">
                                        <p className="input-label">
                                          <FormattedMessage
                                            id="__LbBeneficiaries"
                                            defaultMessage="Recipients"
                                          />
                                        </p>
                                        <div>
                                          {this.state.SelectedEmpId &&
                                          this.state.value == 1 &&
                                          this.state.originalrecipients &&
                                          this.state.originalrecipients.length >
                                            0 ? (
                                            <div
                                              className="team-member-profile position-rel"
                                              style={{ marginLeft: 26 }}
                                            >
                                              {this.state.originalrecipients.map(
                                                (emp) => (
                                                  <Tooltip
                                                    key="key"
                                                    title={emp.employeename}
                                                    placement="bottom"
                                                  >
                                                    <Link
                                                      to={`../../../profile/${emp.employeeid}`}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <div className="inlineClass">
                                                        {emp.imagepath ==
                                                        null ? (
                                                          <img
                                                            src={defaultEmp}
                                                            height="50"
                                                            className="team-avatar"
                                                          />
                                                        ) : (
                                                          <img
                                                            src={getFormattedImageLink(
                                                              emp.imagepath,
                                                            )}
                                                            height="56"
                                                            className="team-avatar"
                                                          />
                                                        )}
                                                      </div>
                                                    </Link>
                                                  </Tooltip>
                                                ),
                                              )}
                                            </div>
                                          ) : (
                                            <div className="padding-bottom-8">
                                              <FormattedMessage
                                                id="LbNorecipients"
                                                defaultMessage="No recipients available"
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div>
                                        <p className="input-label">
                                          <FormattedMessage
                                            id="__LbBeneficiaries"
                                            defaultMessage="Recipients"
                                          />
                                        </p>
                                        <div>
                                          {this.state.originalrecipients &&
                                          this.state.originalrecipients.length >
                                            0 ? (
                                            <div className="team-member-profile position-rel">
                                              {this.state.originalrecipients.map(
                                                (emp) => (
                                                  <Tooltip
                                                    key="key"
                                                    title={emp.employeename}
                                                    placement="bottom"
                                                  >
                                                    <Link
                                                      to={`../../../profile/${emp.employeeid}`}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <div
                                                        className="inlineClass"
                                                        // onClick={this.SetColleagueInfo.bind(this, emp)}
                                                      >
                                                        {emp.imagepath ==
                                                        null ? (
                                                          <img
                                                            src={defaultEmp}
                                                            height="50"
                                                            className="team-avatar"
                                                          />
                                                        ) : (
                                                          <img
                                                            src={getFormattedImageLink(
                                                              emp.imagepath,
                                                            )}
                                                            height="50"
                                                            className="team-avatar"
                                                          />
                                                        )}
                                                      </div>
                                                    </Link>
                                                  </Tooltip>
                                                ),
                                              )}
                                            </div>
                                          ) : (
                                            <div className="padding-bottom-8">
                                              <FormattedMessage
                                                id="LbNorecipients"
                                                defaultMessage="No recipients available"
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {this.state.value == 1 && (
                                      <div>
                                        <p className="input-label">
                                          Leave type
                                        </p>
                                        <div>
                                          <Select
                                            className="selectsearch"
                                            onChange={this.UpdateLeaveId1.bind(
                                              this,
                                            )}
                                            options={
                                              this.state.Leavetypeslist1
                                                .length == 0
                                                ? this.state.filterLeaveTypes
                                                : this.state.Leavetypeslist1
                                            }
                                            getOptionLabel={(option) =>
                                              option.leavename
                                            }
                                            getOptionValue={(option) =>
                                              option.leaveid
                                            }
                                            value={
                                              this.state.selectedLeave1 &&
                                              this.state.selectedLeave1
                                                .leavename
                                                ? this.state.selectedLeave1
                                                : this.state.selectedLeave
                                            }
                                            placeholder="leave type"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {this.state.value == 0 && (
                                      <div>
                                        <p className="input-label">
                                          Leave type
                                        </p>
                                        <div>
                                          <Select
                                            className="selectsearch"
                                            onChange={this.UpdateLeaveId.bind(
                                              this,
                                            )}
                                            options={
                                              this.state.filterLeaveTypes
                                            }
                                            getOptionLabel={(option) =>
                                              option.leavename
                                            }
                                            getOptionValue={(option) =>
                                              option.leaveid
                                            }
                                            value={this.state.selectedLeave}
                                            placeholder="leave type"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {this.state.value == 0 &&
                                      this.state.selectedLeave.leavetypeid ==
                                        3 && (
                                        <div>
                                          <div className="padding-top-15 leavebalance-datepicker">
                                            <div
                                              style={{ position: "relative" }}
                                            >
                                              <DatePickerComponent
                                                placeholder="Select Date"
                                                id="startDate"
                                                allowEdit
                                                format={getEJ2CalenderDateFormat()}
                                                value={this.state.fromdatetime}
                                                min={this.state.minApplyDate}
                                                change={this.SelectfromDate.bind(
                                                  this,
                                                )}
                                              />
                                            </div>
                                            <div className="padding-top-15">
                                              <Grid container>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  md={6}
                                                  sm={12}
                                                >
                                                  <div className="padding-bottom-15">
                                                    <p className="input-label">
                                                      <FormattedMessage
                                                        id="LbFromtime"
                                                        defaultMessage="From Time"
                                                      />
                                                    </p>
                                                    <TextField
                                                      id=""
                                                      margin="dense"
                                                      variant="outlined"
                                                      type="time"
                                                      className="attendancetimeinput"
                                                      onChange={this.updateFromTime.bind(
                                                        this,
                                                      )}
                                                    />
                                                  </div>
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={12}
                                                  md={6}
                                                  sm={12}
                                                >
                                                  <div className="padding-bottom-15">
                                                    <p className="input-label">
                                                      <FormattedMessage
                                                        id="LbTotime"
                                                        defaultMessage="To Time"
                                                      />
                                                    </p>
                                                    <TextField
                                                      id=""
                                                      margin="dense"
                                                      variant="outlined"
                                                      type="time"
                                                      className="attendancetimeinput"
                                                      onChange={this.updateToTome.bind(
                                                        this,
                                                      )}
                                                    />
                                                  </div>
                                                </Grid>
                                              </Grid>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    {this.state.value == 0 &&
                                      this.state.selectedLeave.leavetypeid !=
                                        3 && (
                                        <div className="margin-top-10">
                                          <p className="input-label margin-bottom-8">
                                            <FormattedMessage
                                              id="LbLeaveDaytype"
                                              defaultMessage="Apply leave for"
                                            />
                                          </p>
                                          <RadioGroup
                                            aria-label="daytype"
                                            name="daytype"
                                            value={this.state.selecteddaytype}
                                            onChange={this.onChangeDayType}
                                            row
                                            // className="display-block"
                                          >
                                            <FormControlLabel
                                              value={1}
                                              control={<Radio />}
                                              label="Single day"
                                              className="radio-label"
                                            />
                                            <FormControlLabel
                                              value={2}
                                              control={<Radio />}
                                              label="Multiple days"
                                              className="radio-label"
                                            />
                                          </RadioGroup>

                                          {this.state.selecteddaytype == 1 && (
                                            <div>
                                              <div className="leavebalance-datepicker">
                                                <p className="input-label">
                                                  <FormattedMessage
                                                    id="LbLeaveDate"
                                                    defaultMessage="Your leave date"
                                                  />
                                                </p>
                                                <div
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <DatePickerComponent
                                                    id="startDate"
                                                    allowEdit
                                                    value={
                                                      this.state.fromdatetime
                                                    }
                                                    format={getEJ2CalenderDateFormat()}
                                                    min={
                                                      this.state.minApplyDate
                                                    }
                                                    change={this.SelectfromDate.bind(
                                                      this,
                                                    )}
                                                    className="selectsearch input-area-section"
                                                  />
                                                </div>
                                              </div>
                                              <div className="margin-top-8">
                                                <FormControl
                                                  component="fieldset"
                                                  style={{ zIndex: 0 }}
                                                >
                                                  <p className="input-label margin-bottom-8">
                                                    Leave is for
                                                  </p>
                                                  <div>
                                                    <RadioGroup
                                                      aria-label="Gender"
                                                      name="gender1"
                                                      className={`${classes.group} display-block margin-left-8`}
                                                      value={
                                                        this.state
                                                          .leavestarttypeid
                                                      }
                                                      onChange={
                                                        this.changeleavetype
                                                      }
                                                    >
                                                      <FormControlLabel
                                                        value={1}
                                                        control={
                                                          <Radio className="padding0 padding-right-8" />
                                                        }
                                                        label="Full day"
                                                        className="radio-label"
                                                      />
                                                      {this.state.selectedLeave
                                                        .leavetypeid != 12 && (
                                                        <FormControlLabel
                                                          value={2}
                                                          control={
                                                            <Radio className="padding0 padding-right-8" />
                                                          }
                                                          label="1st half"
                                                          className="radio-label margin-left-0"
                                                        />
                                                      )}
                                                      {this.state.selectedLeave
                                                        .leavetypeid != 12 && (
                                                        <FormControlLabel
                                                          value={3}
                                                          control={
                                                            <Radio className="padding0 padding-right-8" />
                                                          }
                                                          label="2nd half"
                                                          className="radio-label margin-left-0"
                                                        />
                                                      )}
                                                    </RadioGroup>
                                                  </div>
                                                </FormControl>
                                              </div>
                                            </div>
                                          )}
                                          {this.state.selecteddaytype == 2 && (
                                            <div>
                                              <div className="leavebalance-datepicker width100">
                                                <p className="input-label">
                                                  Leave start date
                                                </p>
                                                <div className="position-rel">
                                                  <DatePickerComponent
                                                    value={
                                                      this.state.fromdatetime
                                                    }
                                                    id="startDate"
                                                    allowEdit
                                                    format={getEJ2CalenderDateFormat()}
                                                    min={
                                                      this.state.minApplyDate
                                                    }
                                                    change={this.SelectfromDate.bind(
                                                      this,
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div className="margin-top-8">
                                                <p className="input-label">
                                                  Leave is for
                                                </p>
                                                <div style={{ marginTop: -8 }}>
                                                  <RadioGroup
                                                    aria-label="Gender"
                                                    name="gender1"
                                                    value={
                                                      this.state
                                                        .leavestarttypeid
                                                    }
                                                    onChange={
                                                      this.changestartleavetype
                                                    }
                                                    // eslint-disable-next-line react/jsx-no-duplicate-props
                                                    className="display-block"
                                                    row
                                                  >
                                                    <FormControlLabel
                                                      value={1}
                                                      control={<Radio />}
                                                      label="Full day"
                                                    />
                                                    {this.state.selectedLeave
                                                      .leavetypeid != 12 && (
                                                      <FormControlLabel
                                                        value={3}
                                                        control={<Radio />}
                                                        label="2nd half"
                                                      />
                                                    )}
                                                  </RadioGroup>
                                                </div>
                                              </div>

                                              <div className="leavebalance-datepicker width100">
                                                <p className="input-label">
                                                  Leave end date
                                                </p>
                                                <div className="position-rel">
                                                  <DatePickerComponent
                                                    id="endDate"
                                                    allowEdit
                                                    value={
                                                      this.state.todatetime
                                                    }
                                                    format={getEJ2CalenderDateFormat()}
                                                    min={
                                                      this.state.fromdatetime
                                                    }
                                                    change={this.SelecttoDate.bind(
                                                      this,
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div className="margin-top-8">
                                                <p className="input-label">
                                                  Leave is for
                                                </p>
                                                <div style={{ marginTop: -8 }}>
                                                  <RadioGroup
                                                    aria-label="daytype"
                                                    name="day"
                                                    value={
                                                      this.state.leaveendtypeid
                                                    }
                                                    onChange={
                                                      this.changeendleavetype
                                                    }
                                                    row
                                                    // className="display-block"
                                                  >
                                                    <FormControlLabel
                                                      value={1}
                                                      control={<Radio />}
                                                      label="Full day"
                                                    />
                                                    {this.state.selectedLeave &&
                                                      this.state.selectedLeave
                                                        .leavetypeid != 12 && (
                                                        <FormControlLabel
                                                          value={2}
                                                          control={<Radio />}
                                                          label="1st half"
                                                        />
                                                      )}
                                                  </RadioGroup>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    {this.state.value == 1 &&
                                      this.state.selectedLeave1.leavetypeid ==
                                        3 && (
                                        <div className="padding-top-15 leavebalance-datepicker">
                                          <div style={{ position: "relative" }}>
                                            <DatePickerComponent
                                              placeholder="Select Date"
                                              id="startDate"
                                              allowEdit
                                              format={getEJ2CalenderDateFormat()}
                                              value={this.state.fromdatetime}
                                              min={this.state.minApplyDate}
                                              change={this.SelectfromDate.bind(
                                                this,
                                              )}
                                            />
                                          </div>

                                          <Grid
                                            container
                                            className="padding-top-15"
                                          >
                                            <Grid item xs={12} md={6} sm={12}>
                                              <div className="padding-bottom-15">
                                                <p className="input-label">
                                                  <FormattedMessage
                                                    id="LbFromtime"
                                                    defaultMessage="From Time"
                                                  />
                                                </p>
                                                <TextField
                                                  id=""
                                                  margin="dense"
                                                  variant="outlined"
                                                  type="time"
                                                  className="attendancetimeinput"
                                                  onChange={this.updateFromTime.bind(
                                                    this,
                                                  )}
                                                />
                                              </div>
                                            </Grid>
                                            <Grid item xs={12} md={6} sm={12}>
                                              <div className="padding-bottom-15">
                                                <div className="input-label">
                                                  <FormattedMessage
                                                    id="LbTotime"
                                                    defaultMessage="To Time"
                                                  />
                                                </div>
                                                <TextField
                                                  id=""
                                                  margin="dense"
                                                  variant="outlined"
                                                  type="time"
                                                  className="attendancetimeinput"
                                                  onChange={this.updateToTome.bind(
                                                    this,
                                                  )}
                                                />
                                              </div>
                                            </Grid>
                                          </Grid>
                                        </div>
                                      )}
                                    {this.state.value == 1 &&
                                      this.state.selectedLeave1.leavetypeid !=
                                        3 && (
                                        <div className="margin-top-10">
                                          <p className="input-label margin-bottom-8">
                                            <FormattedMessage
                                              id="LbLeaveDaytype"
                                              defaultMessage="Apply leave for"
                                            />
                                          </p>
                                          <RadioGroup
                                            aria-label="daytype"
                                            name="daytype"
                                            value={this.state.selecteddaytype}
                                            onChange={this.onChangeDayType}
                                            row
                                            // className="display-block"
                                          >
                                            <FormControlLabel
                                              value={1}
                                              control={<Radio />}
                                              label="Single day"
                                              className="radio-label"
                                            />
                                            <FormControlLabel
                                              value={2}
                                              control={<Radio />}
                                              label="Multiple days"
                                              className="radio-label"
                                            />
                                          </RadioGroup>

                                          {this.state.selecteddaytype == 1 && (
                                            <div>
                                              <div className="leavebalance-datepicker">
                                                <p className="input-label">
                                                  <FormattedMessage
                                                    id="LbLeaveDate"
                                                    defaultMessage="Your leave date"
                                                  />
                                                </p>
                                                <div
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <DatePickerComponent
                                                    id="startDate"
                                                    allowEdit
                                                    value={
                                                      this.state.fromdatetime
                                                    }
                                                    format={getEJ2CalenderDateFormat()}
                                                    min={
                                                      this.state.minApplyDate
                                                    }
                                                    change={this.SelectfromDate.bind(
                                                      this,
                                                    )}
                                                    className="selectsearch input-area-section"
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                className="margin-top-8"
                                                style={{ zIndex: 0 }}
                                              >
                                                <p className="input-label margin-bottom-8">
                                                  Leave is for
                                                </p>

                                                <RadioGroup
                                                  aria-label="Gender"
                                                  name="gender1"
                                                  value={
                                                    this.state.leavestarttypeid
                                                  }
                                                  onChange={
                                                    this.changeleavetype
                                                  }
                                                  className="display-block margin-left-8"
                                                >
                                                  <FormControlLabel
                                                    value={1}
                                                    control={
                                                      <Radio className="padding0 padding-right-8" />
                                                    }
                                                    label="Full day"
                                                    className="radio-label"
                                                  />
                                                  {this.state.selectedLeave
                                                    .leavetypeid != 12 && (
                                                    <FormControlLabel
                                                      value={2}
                                                      control={
                                                        <Radio className="padding0 padding-right-8" />
                                                      }
                                                      label="1st half"
                                                      className="radio-label margin-left-0"
                                                    />
                                                  )}
                                                  {this.state.selectedLeave
                                                    .leavetypeid != 12 && (
                                                    <FormControlLabel
                                                      value={3}
                                                      control={
                                                        <Radio className="padding0 padding-right-8" />
                                                      }
                                                      label="2nd half"
                                                      className="radio-label margin-left-0"
                                                    />
                                                  )}
                                                </RadioGroup>
                                              </div>
                                            </div>
                                          )}
                                          {this.state.selecteddaytype == 2 && (
                                            <div>
                                              <div>
                                                <div className="leavebalance-datepicker width100">
                                                  <p className="input-label">
                                                    Leave start date
                                                  </p>
                                                  <div className="position-rel">
                                                    <DatePickerComponent
                                                      id="startDate"
                                                      allowEdit
                                                      value={
                                                        this.state.fromdatetime
                                                      }
                                                      format={getEJ2CalenderDateFormat()}
                                                      min={
                                                        this.state.minApplyDate
                                                      }
                                                      change={this.SelectfromDate.bind(
                                                        this,
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="margin-top-8">
                                                  <p className="input-label">
                                                    Leave is for
                                                  </p>
                                                  <div
                                                    style={{ marginTop: -8 }}
                                                  >
                                                    <RadioGroup
                                                      aria-label="Gender"
                                                      name="gender1"
                                                      value={
                                                        this.state
                                                          .leavestarttypeid
                                                      }
                                                      onChange={
                                                        this
                                                          .changestartleavetype
                                                      }
                                                      // eslint-disable-next-line react/jsx-no-duplicate-props
                                                      className="display-block"
                                                      row
                                                    >
                                                      <FormControlLabel
                                                        value={1}
                                                        control={<Radio />}
                                                        label="Full day"
                                                      />
                                                      {this.state.selectedLeave
                                                        .leavetypeid != 12 && (
                                                        <FormControlLabel
                                                          value={3}
                                                          control={<Radio />}
                                                          label="2nd half"
                                                        />
                                                      )}
                                                    </RadioGroup>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="leavebalance-datepicker width100 margin-bottom-8">
                                                <p className="input-label">
                                                  Leave end date
                                                </p>
                                                <div className="position-rel">
                                                  <DatePickerComponent
                                                    id="endDate"
                                                    allowEdit
                                                    value={
                                                      this.state.todatetime
                                                    }
                                                    format={getEJ2CalenderDateFormat()}
                                                    min={
                                                      this.state.fromdatetime
                                                    }
                                                    change={this.SelecttoDate.bind(
                                                      this,
                                                    )}
                                                  />
                                                </div>
                                              </div>

                                              <p className="input-label">
                                                Leave is for
                                              </p>
                                              <div style={{ marginTop: -8 }}>
                                                <RadioGroup
                                                  aria-label="daytype"
                                                  name="day"
                                                  value={
                                                    this.state.leaveendtypeid
                                                  }
                                                  onChange={
                                                    this.changeendleavetype
                                                  }
                                                  className="display-block"
                                                  row
                                                >
                                                  <FormControlLabel
                                                    value={1}
                                                    control={<Radio />}
                                                    label="Full day"
                                                  />
                                                  {this.state.selectedLeave
                                                    .leavetypeid != 12 && (
                                                    <FormControlLabel
                                                      value={2}
                                                      control={<Radio />}
                                                      label="1st half"
                                                    />
                                                  )}
                                                </RadioGroup>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )}

                                    <p className="input-label margin-top-8">
                                      Additional recipients
                                    </p>
                                    <Select
                                      className="selectsearch width100"
                                      onInputChange={this.SearchEmployee}
                                      onChange={this.UpdateSelectedTagIds.bind(
                                        this,
                                      )}
                                      isMulti
                                      options={this.state.emplist}
                                      getOptionLabel={(option) =>
                                        option.displayname
                                      }
                                      getOptionValue={(option) =>
                                        option.displayvalue
                                      }
                                      value={this.state.SelectedTagIds}
                                      placeholder="Enter employee name"
                                    />
                                  </div>

                                  <p className="input-label margin-top-16">
                                    Reason for request
                                  </p>

                                  <TextArea
                                    className="width100"
                                    maxLength="550"
                                    onChange={this.UpdateComment.bind(this)}
                                    variant="outlined"
                                    multiline
                                  />

                                  {this.state.imgname ? (
                                    <div style={{ marginTop: 16 }}>
                                      <div
                                        style={{
                                          marginRight: 8,
                                          cursor: "pointer",
                                          float: "left",
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          onClick={this.removeImage}
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                          <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                      </div>
                                      <div>{this.state.imgname}</div>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        marginTop: 16,
                                        marginBottom: 16,
                                      }}
                                    >
                                      <p className="input-label">Upload file</p>
                                      <div className="add-attachment">
                                        <Tooltip
                                          title="Insert attachment"
                                          placement="right"
                                        >
                                          <Dropzone
                                            onDrop={this.getFiles1.bind(this)}
                                            multiple={false}
                                            accept="image/gif, image/jpeg, image/png, image/jpg"
                                            maxSize={2000000}
                                            className="drag-drop"
                                          >
                                            <Add className="add-attachement-icon" />
                                          </Dropzone>
                                        </Tooltip>
                                      </div>
                                      <div className="clear-float"> </div>
                                      <p
                                        className="input-label"
                                        style={{ marginTop: 8 }}
                                      >
                                        Note: Upload attachment with max size 2
                                        MB for optimum results. (Supports .gif,
                                        .jpeg, .png and .jpg file types)
                                      </p>
                                    </div>
                                  )}

                                  {applyLeave &&
                                    applyLeave.permissions.editable && (
                                      <div className="clear-float">
                                        <Button
                                          variant="contained"
                                          className="btn btn-primary-md-blue"
                                          onClick={this.ApplyLeave.bind(this)}
                                          disabled={
                                            this.props.SaveInProgressReducer
                                              .issaveinprogress
                                          }
                                        >
                                          Apply Leave
                                        </Button>
                                      </div>
                                    )}
                                </TabContainer>
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.viewLogs ? (
                              <div>
                                <DrawerHeader
                                  header={this.state.selectedLeave.leavename}
                                  isbackarrow={false}
                                  closeDrawer={() => {
                                    this.toggleDrawer("right", false);
                                    this.cleardrawerData();
                                  }}
                                />
                                <div className="clear-float padding-top-16">
                                  <div>
                                    <LabelValue
                                      label="Logs Between"
                                      value={`${getFormattedDate(
                                        startOfMonth,
                                      )} to ${getFormattedDate(endOfMonth)}`}
                                    />
                                  </div>
                                  {this.state.isvisible &&
                                    this.state.leaveLogs.length == 0 && (
                                      <CallOutNew
                                        classnames="bg-light-blue width100"
                                        header="No logs available for this month."
                                        emoji=""
                                        textcolor="#1e8ced"
                                      />
                                    )}
                                  {this.state.leaveLogs.map((options) => (
                                    <div key="key" className="position-rel">
                                      <div
                                        className="floatleft"
                                        style={{ marginRight: 10 }}
                                      >
                                        <img
                                          className="log-empprofile"
                                          src={
                                            options.imagepath
                                              ? getFormattedImageLink(
                                                  options.imagepath,
                                                )
                                              : EmpProfile
                                          }
                                          height="40"
                                        />
                                      </div>
                                      <div
                                        className="request-empprofile-info"
                                        style={{ float: "none", width: "100%" }}
                                      >
                                        <p className="req-message-head history-leave-margin">
                                          <strong>
                                            {options.firstname}
                                            {options.lastname
                                              ? ` ${options.lastname}`
                                              : ""}
                                          </strong>
                                          {options.senderid ==
                                          options.employeeid
                                            ? " has applied for Leave"
                                            : " has applied Leave on your behalf"}
                                          {options.leavetypeid == 3
                                            ? ` for ${
                                                options.totaltime
                                              } Hrs on ${moment(
                                                options.fromdatetime,
                                              ).format("DD-MMM")}`
                                            : moment(
                                                options.fromdatetime,
                                              ).format("DD-MMM") ==
                                              moment(options.todatetime).format(
                                                "DD-MMM",
                                              )
                                            ? ` for ${moment(
                                                options.fromdatetime,
                                              ).format("DD-MMM")}`
                                            : ` from ${moment(
                                                options.fromdatetime,
                                              ).format("DD-MMM")} to ${moment(
                                                options.todatetime,
                                              ).format("DD-MMM")}`}
                                        </p>
                                        <p className="no-padding req-message-cont history-leave-margin">
                                          <strong>Reason: </strong>
                                          {options.reason}
                                        </p>
                                        <p
                                          className="req-message-head history-leave-margin"
                                          style={{ marginLeft: 40 }}
                                        >
                                          <strong>Status: </strong>
                                          {options.statuscode}
                                        </p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.ledger ? (
                              <Ledger
                                {...this.state}
                                {...this.props}
                                selectedLeave={this.state.selectedLeave}
                                getEmpId={this.getEmpId}
                                SelectedEmpData={this.state.SelectedEmpData}
                                leaveoption={this.state.leaveoption}
                                AuthenticationAction={
                                  this.props.AuthenticationAction
                                }
                                enqueueSnackbar={this.props.enqueueSnackbar}
                                toggleDrawer={this.toggleDrawer}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Drawer>
                    </div>
                  ) : (
                    // <Grid container>
                    //   <Grid item xs={12} md={12} sm={12} className="position-rel">
                    // <div className="position-rel">
                    //     {!isFromModule && migrateleave && migrateleave.isenable && (
                    //       <div
                    //         style={{
                    //           float: "right",
                    //           width: 220,
                    //           marginTop: 8,
                    //           color: "#057cff",
                    //           fontWeight: 400,
                    //           cursor: "pointer",
                    //         }}
                    //         onClick={() => {
                    //           window.open(migrateleave.oldurl);
                    //         }}
                    //       >
                    //         View leave in sumHR 2.0
                    //     </div>
                    //     )}
                    //     <DefaultComp
                    //       subheading = {`Your leaves have not been transitioned & carry forwarded to the new cycle ${this.state.displaymonthvaluedata.displayname}. Please toggle the calendar above to view previous month's leaves.`}
                    //       // subheading="You can only view leave balance after a policy has been assigned"
                    //       imageSrc={defaultstateimg}
                    //       permissions={this.state.permissions}
                    //     />
                    //  </div>
                    //   <Grid
                    //   container
                    //   // style={{
                    //   //   position: "relative",
                    //   //   display: "flex",
                    //   //   flexDirection: "row",
                    //   // }}
                    // >
                    //   <Grid item md={8} style={{ paddingLeft: 364 }}>
                    <div
                      className="display-flex"
                      style={{ position: "relative" }}
                    >
                      <DefaultComp
                        // heading="Select atleast one of the filters to see the list of employees"
                        subheading={`Your leaves have not been transitioned & carry forwarded to the new cycle ${this.state.displaymonthvaluedata.displayname}. Please toggle the calendar above to view previous month's leaves.`}
                        imageSrc={defaultstateimg}
                      />
                      <div style={{ top: 10, right: 30, position: "absolute" }}>
                        <img src={curvedArrow} />
                      </div>
                    </div>
                  )}

                  {defaultstate && isFromModule && (
                    <div className="position-rel">
                      <DefaultComp
                        // heading="Select atleast one of the filters to see the list of employees"
                        subheading={`Your leaves have not been transitioned & carry forwarded to the new cycle ${this.state.displaymonthvaluedata.displayname}. Please toggle the calendar above to view previous month's leaves.`}
                        imageSrc={defaultstateimg}
                      />
                      <div
                        style={{ top: -49, right: 137, position: "absolute" }}
                      >
                        <img src={curvedArrow} />
                      </div>
                    </div>
                  )}
                </>
              )}
            </main>
          )}
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
  SubscriptionInfo: state.SubscriptionInfo,
  AuthenticationAction: state.AuthenticationAction,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(LeaveBalance)));
